export default __webpack_public_path__ + "static/media/bs-karada.13f36c44.png";